<template>
	<div class="container-fluid estproForm" id="formDoc">
		<form @submit.prevent="saveEstimates()" class="col-12">
            <div class="row">
                <div class="alert alert-danger" role="alert" v-if="errors.length">
                    <ul style="margin-bottom: 0">
                        <li v-for="error in errors" :key="error">{{ error }}</li>
                    </ul>
                </div>
            </div>
            <div class="row" style="position: fixed;top: 58px;right: 60px;width: 60%;z-index: 9;height: 30px;">
                <div class="col-12 text-right">
                    <button type="submit" class="btn btn-success"  style="margin-bottom: 0.5rem;">
                        <i class="fas fa-save"></i> SAVE
                    </button>
                </div>
            </div>
            <div class="row" style="background-color: #f1f1f1;padding: 8px;margin-bottom: 12px;">
                <div class="col-2">
                    <label for="est_status">Status</label>
                    <select class="form-control" v-model="formEstimates.status" id="est_status">
                        <option :value="1">Pending</option>
                        <option :value="2">Accepted</option>
                        <option :value="3">Rejected</option>
                    </select>
                </div>
                <div class="col-8">
                    <label for="accepted_by">Accepted By</label>
                    <input type="text" class="form-control" v-model="formEstimates.accepted_by" id="accepted_by"/>
                </div>
                <div class="col-2">
                    <date-doc :dateDoc="new Date(formEstimates.date_create)" :labelDoc="'Document Date:'" ref="dateDoc" @returnValue="getResponseDateDoc($event, 'date_create')"></date-doc>
                </div>
            </div>
            <div class="row">
                <div class="col-6">
                    <label for="CustomersList" style="position: relative;width: 100%;display: block;">Customer</label>
                    <div class="form-group"  >
                        <model-select
                            id="CustomersList"
                            :options="CustomersList"
                            v-model="ValuesCustomers"
                            placeholder="Choose a Customer"
                        ></model-select>
                    </div>
                    <div class="col-12" style="padding:0;">
                        <!-- <label for="inputEmail4">Bill To</label> -->
                        <div class="form-group bill_to">
                            <div>
                                <span>
                                    {{ ValuesCustomers.customer_name }}
                                </span>
                                <span>
                                    {{ ValuesCustomers.customer_lastname}}
                                </span>
                            </div>
                            <div v-if="ValuesCustomers.bussinesname!=null && ValuesCustomers.bussinesname!='' && ValuesCustomers.bussinesname!='null'">
                                {{ ValuesCustomers.bussinesname }}&nbsp;
                            </div>
                            <div v-if="ValuesCustomers.billing_address!=''">
                                {{ ValuesCustomers.billing_address }}
                            </div>
                            <div
                                v-if="ValuesCustomers.city!=null ||
                                ValuesCustomers.state!=null ||
                                ValuesCustomers.code!=null 
                                "
                            >
                                <span v-if="ValuesCustomers.city!=null">{{ ValuesCustomers.city }}&nbsp;</span>
                                <span v-if="ValuesCustomers.state!=null">{{ ValuesCustomers.state }}</span>
                                <span v-if="ValuesCustomers.code!=null && (ValuesCustomers.state==null || ValuesCustomers.state=='')">,&nbsp;</span><span v-else>&nbsp;</span>
                                <span v-if="ValuesCustomers.code!=null">{{ ValuesCustomers.code }}</span>
                            </div>
                            <div>
                                <span v-if="ValuesCustomers.customer_phone!=null">
                                    {{ ValuesCustomers.customer_phone }}
                                </span>
                                <span v-if="ValuesCustomers.customer_officephone!=null">
                                    <span v-if="ValuesCustomers.customer_phone!=null && ValuesCustomers.customer_officephone!=''">&nbsp;/&nbsp;</span>
                                    {{ ValuesCustomers.customer_officephone }}
                                </span>
                            </div>
                            <div v-if="ValuesCustomers.email!=null">
                                {{ ValuesCustomers.email }}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-6" >
                    <div class="row">
                        <infoEst :controlLoad="formEstimates.idEst" :propdocument_name="formEstimates.estimates_optional"
                        :propjob_information="formEstimates.job_information" :propdisabledSteps="disabledSteps" propCols="12" @updateProps="updateJobInfo($event)"/>
                    </div>
                </div>
            </div>
            <div id="sec-products" v-if="loadEstByID" >
                    <table_ePro :controlLoad="loadEstByID" :propdisabledSteps="disabledSteps"
                        :propForm="formEstimates" :propItemsprod="itemsprod" :proptaxShow="taxShow" :propgroupShow="groupShow"
                        @addProdct="NewProducts" @updateProdcts="setProd" />
                </div>
            <div class="row" v-if="!disabledSteps.customer" >
                <customerMessage v-if="loadEstByID" :controlLoad="loadEstByID" :propdisabledSteps="disabledSteps"
                    :propForm="formEstimates" @updateProps="setMessage" :propTotal="formEstimates.total" :propNavCustomer="navCustomer"
                        :propPayment="paymentPlan" @updateNavCustomer="changeNavCustomer" @updatePropsPayment="setPayments" />
                <div class="col-7">
                    <resumenTotal v-if="loadEstByID" :controlLoad="loadEstByID" :propdisabledSteps="disabledSteps"
                        :propForm="formEstimates" :propTaxesResumen="taxesResumen" :propItemsprod="itemProducts"
                        :proptaxShow="taxShow" :propgroupShow="groupShow" @setAlertError="setAlert"
                        @updateTotales="setTotales" />
                </div>
            </div>
            <navContract v-if="!disabledSteps.customer" :contract="formEstimates" :propSelectedIndex="selectedContract" @updateNavContract="setNavContract" @includeToDocument="showFormOption"/>
            <div v-if="!disabledSteps.customer" class="row" id="contrato">
                <div class="pageSignature col-12">
                    <div class="row" v-if="selectedContract == 1">
                        <needAcontract :propdisabledSteps="disabledSteps" :propForm="formEstimates"
                            :propFormSignature="FormSignature" :propSelectCTemplate="selectCTemplate"
                            @updateContract="setContract" />
                    </div>
                    <div class="row" v-if="selectedContract == 2">
                        <simpleLetter :propdisabledSteps="disabledSteps" :propForm="formEstimates"
                            :propFormSignature="FormSignature" :propTemplateLetter="templateLetter" @updateLetter="setLetter" />
                    </div>
                    <div class="row" v-if="selectedContract == 3">
                        <attachImg :propForm="formEstimates" @updateAttachImg="setAttachImg" />
                    </div>
                </div>
            </div>
            <!-- contrato
            <div class="row">
                <div class="pageSignature">
                    <div
                        class="form-inline"
                        style="border-bottom: 1px solid #ccc"
                    >
                        <div class="my-1 mr-2">
                            Need a Contract?
                        </div>
                        <div
                            class="custom-control custom-checkbox my-1 mr-sm-2"
                        >
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="customControlInline"
                                v-model="
                                    formEstimates.checked
                                "
                            />
                            <label
                                class="custom-control-label"
                                for="customControlInline"
                                >Yes</label
                            >
                        </div>
                        <div
                            class="form-group"
                            v-if="formEstimates.checked"
                            style="
                                margin-right: 5px;
                                margin-left: 15px;
                            "
                        >
                            <input
                                type="text"
                                class="form-control"
                                v-model="
                                    selectCTemplate.title
                                "
                                placeholder="Terms & Conditions"
                            />
                        </div>
                        <div class="my-1 mr-2" v-if="formEstimates.checked && PlanPremium">
                            Request Digital Signature?
                        </div>
                        <div
                            class="custom-control custom-checkbox my-1 mr-sm-2"
                            v-if="formEstimates.checked && PlanPremium"
                        >
                            <input
                                type="checkbox"
                                class="custom-control-input"
                                id="signe"
                                v-model="
                                    formEstimates.signe
                                "
                            />
                            <label
                                class="custom-control-label"
                                for="signe"
                                >Yes</label
                            >
                        </div>
                    </div>
                    <vue-editor
                        v-model="selectCTemplate.description"
                        v-if="formEstimates.checked"
                    />
                    <h5
                        style="padding-top: 20px"
                        v-if="formEstimates.checked"
                    >
                        Signature:
                    </h5>
                    <div
                        class="row"
                        v-if="formEstimates.checked"
                    >
                        <div class="col">
                            <div class="form-group row">
                                <label
                                    for=""
                                    class="col-sm-2 col-form-label"
                                    >Name</label
                                >
                                <div class="col-sm-10">
                                    <input
                                        type="text"
                                        class="form-control"
                                        id=""
                                        v-model="
                                            ValuesCustomers.text
                                        "
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for=""
                                    class="col-sm-2 col-form-label"
                                    >Date</label
                                >
                                <div class="col-sm-10">
                                    <datetime
                                        type="date"
                                        v-model="
                                            FormSignature.dateCustomer
                                        "
                                        value-zone="America/New_York"
                                        input-class="form-control"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                        <div class="col">
                            <div class="form-group row">
                                <label
                                    for=""
                                    class="col-sm-2 col-form-label"
                                    >Name</label
                                >
                                <div class="col-sm-10">
                                    <input
                                        type="text"
                                        class="form-control"
                                        v-model="
                                            FormSignature.nameCompany
                                        "
                                    />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label
                                    for=""
                                    class="col-sm-2 col-form-label"
                                    >Date</label
                                >
                                <div class="col-sm-10">
                                    <datetime
                                        type="date"
                                        v-model="
                                            FormSignature.dateCompany
                                        "
                                        value-zone="America/New_York"
                                        input-class="form-control"
                                    ></datetime>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            -->
		</form>
        <!-- modal -->
	</div>
</template>
<script>
import { mapGetters } from 'vuex'
import { ModelSelect } from 'vue-search-select'
import { VueEditor } from 'vue2-editor'
import '@/apps/billing/views/estpro/form.scss';
import setDateDoc from '@/apps/billing/components/estpro/setDateDoc.vue';
import infoEst from '@/apps/billing/components/estpro/secForm/infoEst.vue';
import table_ePro from '@/apps/billing/components/estpro/secForm/table_ePro.vue';
import customerMessage from '@/apps/billing/components/estpro/secForm/customerMessage.vue';
import resumenTotal from '@/apps/billing/components/estpro/secForm/resumenTotal.vue';
import needAcontract from '@/apps/billing/components/estpro/secForm/needAcontract.vue';
import simpleLetter from '@/apps/billing/components/estpro/secForm/simpleLetter.vue';
import attachImg from '@/apps/billing/components/estpro/secForm/attachImg.vue';
import navContract from '@/apps/billing/components/estpro/secForm/navContract.vue';

export default {
	name: 'crearEst',
	components: {
		ModelSelect,
        VueEditor,
        "date-doc": setDateDoc,
        infoEst,
        table_ePro,
        customerMessage,
        resumenTotal,
        needAcontract,
        simpleLetter,
        attachImg,
        navContract,
	},
	data () {
		return {
            saveDisabled: true,
            loadEstByID: false,
            disabledSteps: {
                startNumer: false,
                customer: true,
                nameEst: false,
                jobsInfo: false,
                products: false,
            },
            taxShow: 0,
            groupShow: 0,
            formEstimates: {
                idEst: null,
                titlePage: "Add Estimate",
                btnName: "SAVE",
                actionNname: "create", // update
                customer_id: null,
                numdoc: null,
                customer_name: null,
                customer_email: null,
                customer_address: null,
                billing_address: null,
                estimates_optional: null,
                status: 1,
                accepted_by: null,
                accepted_date: new Date((new Date().toISOString() + "").slice(0, 10) + "T13:31:04.000Z").toISOString(),
                job_information: null,
                customer_message: null,
                date_create: new Date((new Date().toISOString() + "").slice(0, 10) + "T13:31:04.000Z").toISOString(),
                subtotal: 0,
                discount_type: 1,
                discount_mount: 0.00,
                discount_total: 0.00,
                discount_name: '',
                total: 0,
                totaltax: null,
                qty: null,
                checked: false,
                signe: false,
                letter: false,
                isAttacImg: false,
                attcImg: [],
                dataItems: [],
                optionsExtras: {
                    navCustomer: {
                        textBox: true,
                        payment: false,
                    },
                    paymentPlan: null,
                },
            },
            navCustomer: null,
            paymentPlan: null,
            ContractTemLists: [],
            selectedContract: 0,
            selectCTemplate: {
                id: 0,
                title: "Contract Title",
                description: "",
            },
            templateLetter: {
                title: "Letter Title",
                description: "",
            },
            FormSignature: {
                // nameCustomer: null,
                dateCustomer: new Date(),
                dateCompany: new Date(),
                nameCompany: localStorage.getItem("nomCompany"),
            },
            CustomersList: [],
			ValuesCustomers: {
                text: null,
                value: 0,
                billing_address: null,
                bussinesname: null,
                customer_address: null,
                customer_name: null,
                customer_phone: null,
                customer_officephone: null,
                email: null,
            },
            inputFecha: new Date((new Date().toISOString() + "").slice(0, 10) + "T23:31:04.000Z").toISOString(),
            taxesResumen: [],
            jobinfomationcheck: true,
            jobinfomationtitle: "Job information",
            jobinfomationtext: null,
            dateCustomer: new Date().toISOString().slice(0, 10),
            dateCompany: new Date().toISOString().slice(0, 10),
            accepted_date: new Date().toISOString().slice(0, 10),
            ProdServiceLists: [],
            TaxesLists: [],
            itemsprod: [],
            itemProducts: [],
            formList: {
                items: [],
            },
            errors: [],
            TypeofAccount: [],
            PlanPremium : (window.OrgPlan > 1),
            m: {
                show: false,
                component: '',
                data: []
            },
            modalBill: [
                'NotesAdmin',
                'formCustomer',
                'formProducts',
                'StartEstimate',
            ],
            FormAddPS: {
                vatError: false,
                vatErrorMsg: null,
                index_modal: null,
                btnName: "SAVE",
                Action: "Add",
                id: null,
                productname: null,
                account_id: 0,
                quantity: 1,
                unitcost: 0,
                description: null,
                applytax: 0,
                status: 0,
            },
		}
	},
	created(){
        console.log('crearEst');
        document.querySelector('.body').style.overflowY='hidden';
        this.PlanPremium = (this.$store.getters['core/Org/getPlanId'] > 1);
        if(this.$parent.step==2){
            this.getCustomerID();
            // this.getTaxes();
            this.getCTemplates();
            // this.getAccountTypes();
            if(this.$parent?.dataSales?.est_id && this.$parent?.dataSales?.est_id>0){
                console.log('EstimateById', this.$parent.dataSales.est_id);
                this.formEstimates.actionNname = "update";
                localStorage.removeItem('groupItem'); // reset
                localStorage.removeItem('itemProducts'); // reset
                this.EstimateById();
            }
        }
	},
    beforeDestroy() {
        document.querySelector('.body').removeAttribute('style');
        this.$store.commit('core/setOpenModal', { show: false, component: '', data: [] });
    },
	methods : {
        getCustomerID() {
            let t = this;
            t.$parent.isLoading = true;
            window.billingSales
            .post("customer/" + t.$parent.customerId)
            .then((response) => {
                // console.log('getCustomerID', response.data.result);
                if (response.data.result.length>0) {
                    // console.log('getCustomerID', response.data.result[0]);
                    var id = response.data.result[0].id;
                    var name = response.data.result[0].firstname;
                    var billing_address =
                        response.data.result[0].billingaddress;
                    var customer_address = response.data.result[0].address;
                    var bussinesname = response.data.result[0].bussinesname;
                    var email = response.data.result[0].email;
                    var lastname = response.data.result[0].lastname;
                    var customer_phone = response.data.result[0].mobilephone;
                    var customer_officephone = response.data.result[0].officephone;
                    var city = response.data.result[0].bcity;
                    var state = response.data.result[0].bstate;
                    var code = response.data.result[0].bpostcode;
                    lastname = lastname != null ? lastname : "";
                    email = email != null ? email : "";
                    bussinesname = bussinesname != null ? bussinesname : "";
                    city = city != null ? city + "," : "";
                    state = state != null ? state : "";
                    code = code != null ? code : "";
                    customer_address = customer_address != null ? customer_address : "";
                    customer_officephone = customer_officephone != null ? customer_officephone : "";
                    let guion = '-';
                    let customer= {
                        text: name + " " + lastname + ((bussinesname!='') ? " "+guion +" "+bussinesname : ''),
                        value: id,
                        billing_address: billing_address,
                        bussinesname: bussinesname,
                        customer_address: customer_address,
                        customer_name: name,
                        customer_lastname: lastname,
                        customer_phone: customer_phone,
                        customer_officephone: customer_officephone,
                        email: email,
                        city: city,
                        state: state,
                        code: code,
                    };
                    t.ValuesCustomers =customer;
                    t.CustomersList.push(customer);
                }
                this.disabledSteps.customer = false;
                if(this.$parent.dataSales.est_id!=null && this.$parent.dataSales.est_id==0){
                    console.log('nuevo estimate', this.$parent.dataSales);
                    this.formEstimates.customer_id = id;
                    console.log("customer_id", this.formEstimates.customer_id);
                    t.$parent.isLoading = false;
                    this.loadEstByID = true;
                }
            })
            .catch((error) => {
                console.log(error);
                t.$parent.isLoading = false;
            });
        },
        getAccountTypes() {
            let t = this;
            window.billingSales
                .get("chart-account-list/" + window.localuserdata)
                .then((response) => {
                    t.TypeofAccount = response.data.result;
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        NewProducts(item, index) {
            let t = this;
            t.FormAddPS.index_modal = index;
            t.$parent.$parent.m = {
                show: true,
                component: 'formProducts',
                data: {
                    FormAddPS:t.FormAddPS,
                    TypeofAccount:t.TypeofAccount,
                    TaxesLists:t.TaxesLists,
                    formList:t.formList
                }
            }
            t.$store.commit('core/setOpenModal', t.$parent.$parent.m);
        },
        saveEstimates_old() {
            let t = this;
            this.$parent.isLoading = true;
            this.saveDisabled = true;
            this.errors = [];
            if (!this.ValuesCustomers.value) {
                //this.errors.push('Must select "Customer"');
                this.msjAlert('Must select "Customer')
                this.$parent.isLoading = false;
                this.saveDisabled = false;
                return false;
            }
            if (this.formEstimates.total == 0) {
                // this.errors.push("Total must not be greater than zero");
                this.msjAlert("Total must not be greater than zero")
                this.$parent.isLoading = false;
                this.saveDisabled = false;
                return false;
            }
            if (this.ValuesCustomers.value && this.errors.length == 0) {
                let sendData = {
                    user_id: window.localuserdata,
                    numdoc: this.formEstimates.numdoc,
                    customer_id: this.ValuesCustomers.value,
                    estimate_optional: this.formEstimates.estimates_optional,
                    status: this.formEstimates.status,
                    accepted_by: this.formEstimates.accepted_by,
                    accepted_date: this.formEstimates.accepted_date,
                    job_information: this.formEstimates.job_information,
                    customer_message: this.formEstimates.customer_message,
                    need_contract: this.formEstimates.checked,
                    signe: this.formEstimates.signe,
                    terms_conditions_title: this.selectCTemplate.title,
                    terms_conditions_desc: this.selectCTemplate.description,
                    signaturecustomer: this.ValuesCustomers.text,
                    signaturecustomerdate: this.FormSignature.dateCustomer,
                    signaturecompany: this.FormSignature.nameCompany,
                    signaturecompanydate: this.FormSignature.dateCompany,
                    date_create: this.formEstimates.date_create,
                    sub_total: this.formEstimates.subtotal,
                    discount_type: this.formEstimates.discount_type,
                    discount_mount: this.formEstimates.discount_mount,
                    discount_total: this.formEstimates.discount_total,
                    discount_name: this.formEstimates.discount_name,
                    total: this.formEstimates.total,
                    options_extras: JSON.stringify(this.formEstimates.optionsExtras),
                    dataItems: this.itemsprod,
                    taxShow: this.taxShow,
                    type_estimate: 'pro',
                    groupShow: this.groupShow,
                }
                console.log('sendData', sendData)
                if (this.formEstimates.actionNname == "create") {
                    window.billingSales
                    .post("estimates/add", sendData)
                    .then((response) => {
                        this.saveDisabled = false;
                        console.log('add est', response.data);
                        t.salesSetEstID(response.data.Estimates, 'add');
                    })
                    .catch((error) => {
                        console.log(error);
                        this.$parent.isLoading = false;
                        this.saveDisabled = false;
                        this.$notify({
                            group: "noti",
                            title: "Error!",
                            type: "error",
                            text: "Add Estimate",
                        });
                    });
                }
                if (this.formEstimates.actionNname == "update") {
                    window.billingSales
                        .post("estimate/edit/" + this.formEstimates.idEst, sendData)
                        .then((response) => {
                            this.saveDisabled = false;
                            console.log(response.data);
                            this.$notify({
                                group: "noti",
                                title: "Updated",
                                type: "success",
                                text: "Successful Updated",
                            });
                            console.log("estimate/edit", response.data);
                            t.salesSetEstID(response.data.Estimates, 'update');
                        })
                        .catch((error) => {
                            console.log(error);
                            this.saveDisabled = false;
                            this.$parent.isLoading = false;
                            this.$parent.$parent.CloseModalPopFull()
                        });
                }
            }
        },
        createDataSend() {
            let isContract = this.selectCTemplate?.description!=null && this.selectCTemplate?.description.length > 0 ? 1 : 0;
            let isLetter = this.templateLetter?.description!=null && this.templateLetter?.description.length > 0 ? 1 : 0;
            return {
                user_idd: window.master_client,
                user_id: window.localorgdata,
                org_id: window.localorgdata,
                oauth_m: window.oauth_m,
                socket_id: pusher.connection.socket_id,
                idEst: this.formEstimates.idEst,
                id: this.formEstimates.idEst,
                numdoc: this.formEstimates.numdoc,
                customer_id: this.formEstimates.customer_id,
                estimate_optional: this.formEstimates.estimates_optional,
                status: this.formEstimates.status,
                accepted_by: this.formEstimates.accepted_by,
                accepted_date: this.formEstimates.accepted_date,
                job_information: this.formEstimates.job_information,
                customer_message: this.formEstimates.customer_message,
                need_contract: this.formEstimates.checked ? 1 : 0,
                isLetter: this.formEstimates.letter ? 1 : 0,
                signe: this.formEstimates.signe,
                terms_conditions_title: this.selectCTemplate.title,
                terms_conditions_desc: this.selectCTemplate.description,
                letter_title: this.templateLetter.title,
                letter_description: this.templateLetter.description,
                isAttacImg: this.formEstimates.isAttacImg ? 1 : 0,
                attcImg: JSON.stringify(this.formEstimates.attcImg),
                options_extras: JSON.stringify(this.formEstimates.optionsExtras),
                signaturecustomer: this.ValuesCustomers.text,
                signaturecustomerdate: this.FormSignature.dateCustomer,
                signaturecompany: this.FormSignature.nameCompany,
                signaturecompanydate: this.FormSignature.dateCompany,
                date_create: this.formEstimates.date_create,
                sub_total: this.formEstimates.subtotal,
                discount_type: this.formEstimates.discount_type,
                discount_mount: this.formEstimates.discount_mount,
                discount_total: this.formEstimates.discount_total,
                discount_name: this.formEstimates.discount_name,
                total: this.formEstimates.total,
                dataItems: this.itemProducts,
                taxShow: this.taxShow,
                type_estimate: 'pro',
                groupShow: this.groupShow,
                duplicateEstId: isNaN(this.formEstimates.duplicateEstId) ? 0 : Number(this.formEstimates.duplicateEstId),
            };
        },
        debuggerData(sendData) {
            const ignore = [
                "accepted_by",
                "discount_name",
                "idEst",
                "id",
                "numdoc",
                "estimate_optional",
                "accepted_date",
                "job_information",
                "customer_message",
                "terms_conditions_title",
                "terms_conditions_desc",
                "letter_title",
                "letter_description",
                "isAttacImg",
                "attcImg",
            ];
            const errors = Object.keys(sendData).filter(field => {
                let isValid = sendData[field] !== undefined && sendData[field] !== null;
                if (ignore.indexOf(field) > -1) { isValid = true; }
                if (!isValid) {
                    console.log(`El campo "${field}" no cumple con las reglas de validación.`);
                    this.msjAlert(`El campo "${field}" no cumple con las reglas de validación.`);
                }
                return !isValid;
            });
            return (errors.length === 0)
        },
        isChangeData(sendData) {
            const original = JSON.parse(localStorage.getItem("dataOrigin"));
            if (original) {
                const modifiedFields = Object.keys(original).filter(
                    key => original[key] !== sendData[key]
                );
                if (modifiedFields.length > 0) {
                    // console.log("Campos modificados:", modifiedFields);
                    return true;
                    // modifiedFields .forEach(field => {
                    //     console.log(`Campo: ${field}, Valor original: ${original[field]}, Nuevo valor: ${sendData[field]}`);
                    // });
                } else {
                    // console.log("No se modificaron campos.");
                    return false;
                }
            }
            return false;
        },
        // save, get, del
        saveEstimates() {
            let t = this;
            t.$parent.isLoading = true;
            t.errors = [];
            setTimeout(() => {
                if (!t.formEstimates.customer_id) {
                    t.msjAlert('Must select "Customer')
                    t.$parent.isLoading = false;
                    t.saveDisabled = false;
                    return false;
                }
                if (t.formEstimates.total == 0) {
                    // t.errors.push("Total must not be greater than zero");
                    t.msjAlert("Total must not be greater than zero")
                    t.$parent.isLoading = false;
                    t.saveDisabled = false;
                    return false;
                }
                if (t.formEstimates.customer_id && t.errors.length == 0) {
                    let sendData = t.createDataSend();
                    console.log(t.formEstimates.actionNname, sendData)
                    if (!t.debuggerData(sendData)) {
                        // si hay errores cancelamos la carga
                        t.$parent.isLoading = false;
                        t.saveDisabled = false;
                    }
                    else {
                        let action = t.formEstimates.actionNname == "create" || t.formEstimates.actionNname == "duplicate" ? 'add' : 'update';
                        if (action == "add") {
                            window.billingSales.post("estimates/add", sendData)
                                .then((response) => {
                                    t.saveDisabled = false;
                                    // t.$router.push({ name: t.rutaPrincipal });
                                    t.salesSetEstID(response.data.Estimates, action);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    t.$parent.isLoading = false;
                                    t.saveDisabled = false;
                                    t.$parent.$parent.CloseModalPopFull()
                                });
                        }
                        else if (t.formEstimates.actionNname == "update") {
                            // caso contrario enviamos a guardar
                            window.billingSales.post("estimate/edit/" + t.formEstimates.idEst, sendData)
                                .then((response) => {
                                    t.saveDisabled = false;
                                    // console.log(response.data);
                                    t.$notify({
                                        group: "noti",
                                        title: "Updated",
                                        type: "success",
                                        text: "Successful Updated",
                                    });
                                    t.salesSetEstID(response.data.Estimates, action);
                                })
                                .catch((error) => {
                                    console.log(error);
                                    t.$parent.isLoading = false;
                                    t.saveDisabled = false;
                                    t.$parent.$parent.CloseModalPopFull()
                                });
                        }
                    }
                }
            }, 1000);
        },
        getProdservices() {
            window.billingSales
                .get("product-services/" + window.localuserdata)
                .then((response) => {
                    // console.log("product sevice list table");
                    //this.ProdServiceLists = response.data.result
                    const ProdList = [{
                        value: 0,
                        text: "Uncategorized",
                        description: "",
                        unitcost: "1.00",
                        qty: "1.00",
                        taxOpc: {
                            id: 0,
                            name: '--None--',
                            porcentaje: '',
                            initialstate: '',
                            statename: '',
                            count: 0,
                            total: 0,
                        },
                        applytax: 0,
                        prices: 0
                    }];
                    if (response.data.result) {
                        for (let item in response.data.result) {
                            var id = response.data.result[item].id;
                            var prodname = response.data.result[item].productname;
                            var quantity = this.formatUSD(response.data.result[item].quantity);
                            var unitcost = this.formatUSD(response.data.result[item].unitcost);
                            var descripcion = response.data.result[item].description;
                            var applytax = response.data.result[item].applytax;
                            let taxOpcID = {
                                id: 0,
                                name: 'None',
                                porcentaje: '',
                                initialstate: '',
                                statename: '',
                                count: 0,
                                total: 0,
                            };
                            for (let i in this.TaxesLists) {
                                if (
                                    this.TaxesLists[i].id ==
                                    response.data.result[item].applytax
                                ) {
                                    taxOpcID = this.TaxesLists[i];
                                }
                            }
                            ProdList.push({
                                value: id,
                                text: prodname,
                                unitcost: unitcost,
                                descripcion: descripcion,
                                qty: quantity,
                                taxOpc: taxOpcID,
                                applytax: applytax,
                            });
                        }
                    }
                    this.ProdServiceLists = ProdList;
                    // console.log("ProdList ", this.ProdServiceLists);
                    if(this.$parent.dataSales.est_id && this.$parent.dataSales.est_id>0){
                        console.log('EstimateById', this.$parent.dataSales.est_id);
                        this.EstimateById();
                    }else{
                        this.addNewLinePrimary();
                        this.$parent.isLoading = false;
                    }
                })
                .catch((error) => {
                    this.$parent.isLoading = false;
                    console.log(error);
                });
        }, 
        salesSetEstID(est, action) {
            let t = this;
            window.master
                .post("salesSetEstID", {
                org_id: window.localorgdata,
                user_id: window.master_client,
                idSale: t.$parent.dataSales.id,
                est_id: est.id,
                numdoc: est.numdoc,
                statusEstimate: est.status,
                customer_id: est.customer_id
                })
                .then((response) => {
                    if(action=='add')
                    {
                        this.$notify({
                            group: "noti",
                            title: "Created!",
                            type: "success",
                            text: "Successful registration",
                        });
                    }
                    this.$parent.isLoading = false;
                    console.log("salesSetEstID", response.data);
                    this.$parent.$parent.CloseModalPopFull();
                    this.$parent.$parent.getSalesCount();// actualizar contadores
                    this.$parent.$parent.navTabs(5, 4); // actualizar tab y lista
                })
                .catch((error) => {
                    console.log(error);
                    this.$parent.isLoading = false;
                    this.$notify({
                        group: "noti",
                        title: "Error!",
                        type: "error",
                        text: "Sync Estimate",
                    });
                });
        },
        getCTemplates() {
            window.billingSales
                .get("contracttemplate/" + window.localuserdata)
                .then((response) => {
                    console.log("template estimates list");
                    console.log(response.data);
                    this.ContractTemLists = response.data.result;
                    console.log('actionNname', this.formEstimates.actionNname)
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        getTaxes() {
            window.billingSales
                .get("taxes/" + window.localuserdata)
                .then((response) => {
                    console.log("taxes request all");
                    //console.log(response.data)
                    //this.TaxesLists = response.data;
                    const ObjTaxes = [{
                            id: 0,
                            name: '--None--',
                            porcentaje: '',
                            initialstate: '',
                            statename: '',
                            count: 0,
                            total: 0,
                        }];
                    if (response.data) {
                        for (let item in response.data) {
                            var id = response.data[item].id;
                            var initialstate = response.data[item].initialstate;
                            var name = response.data[item].name;
                            var state_id = response.data[item].state_id;
                            var statename = response.data[item].statename;
                            var status = response.data[item].status;
                            var user_id = response.data[item].user_id;
                            ObjTaxes.push({
                                id: id,
                                initialstate: initialstate,
                                name: name,
                                state_id: state_id,
                                statename: statename,
                                status: status,
                                user_id: user_id,
                                default: "none",
                            });

                            this.taxesResumen.push({
                                id: id,
                                name: initialstate,
                                porcentaje: name,
                                initialstate: initialstate,
                                statename: statename,
                                count: 0,
                                total: 0,
                            });
                        }
                    }else{
                    }
                    this.TaxesLists = ObjTaxes;
                    this.getProdservices();
                })
                .catch((error) => {
                    console.log(error);
                });
        },
        msjAlert(msj){
            this.$notify({
                group: "noti",
                title: "Error",
                type: "error",
                text: msj
            });
        }, 
        formatUSD(amount) {    
            if (Number(amount)) return amount;
            let vatIdRegex = new RegExp(/^[0-9.,-]+$/); 
            let value = ''     
            let val = 0.0;
            if (vatIdRegex.test(amount)) {
                let ops = {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2,
                };
                let numberFormat2 = new Intl.NumberFormat('en-US', ops);  
                value = numberFormat2.format(amount)                
                // console.log('numberFormat2', numberFormat2.format(amount)); // amount
                if (value.indexOf(".") > -1) {
                    val = value;
                } else {
                    val = value + ".00";
                }
            }
            return val
        }, 
        addNewLinePrimary() {
            const ProdList = [];
            for (let item in this.ProdServiceLists) {
                var id = this.ProdServiceLists[item].value;
                var prodname = this.ProdServiceLists[item].text;
                var quantity = this.ProdServiceLists[item].qty;
                var unitcost = this.ProdServiceLists[item].unitcost;
                var descripcion = this.ProdServiceLists[item].descripcion;
                var applytax = this.ProdServiceLists[item].applytax;
                let taxOpcID = {
                    id: 0,
                    name: '--None--',
                    porcentaje: '',
                    initialstate: '',
                    statename: '',
                    count: 0,
                    total: 0,
                };
                for (let i in this.TaxesLists) {
                    if (this.TaxesLists[i].id == this.ProdServiceLists[item].applytax) {
                        taxOpcID = this.TaxesLists[i];
                    }
                }
                ProdList.push({
                    value: id,
                    text: prodname,
                    unitcost: unitcost,
                    descripcion: descripcion,
                    qty: quantity,
                    taxOpc: taxOpcID,
                });
            }
            if (this.formEstimates.actionNname == "create") {
                this.formList.items.push({
                    options: ProdList,
                    taxlistOption: this.TaxesLists,
                    model: {
                        value: 0,
                        text: "Uncategorized",
                        description: "",
                        unitcost: "1.00",
                        qty: "1.00",
                        taxOpc: {
                            id: 0,
                            name: '--None--',
                            porcentaje: '',
                            initialstate: '',
                            statename: '',
                            count: 0,
                            total: 0,
                        },
                        applytax: 0,
                        prices: 0
                    },
                });
            }
        },
        formatearFechaContrato2() {
            this.FormSignature.dateCustomer = new Date(
                (new Date(this.FormSignature.dateCustomer).toISOString() + "").slice(
                    0,
                    10
                ) + "T23:31:04.000Z"
            ).toISOString();
        },
        formatearFechaContrato() {
            this.FormSignature.dateCompany = new Date(
                (new Date(this.FormSignature.dateCompany).toISOString() + "").slice(
                    0,
                    10
                ) + "T23:31:04.000Z"
            ).toISOString();
        },
        formatearFecha() {
            this.inputFecha = new Date(
                (new Date(this.inputFecha).toISOString() + "").slice(0, 10) +
                    "T23:31:04.000Z"
            ).toISOString();
        },
        formatearFecha2() {
            this.formEstimates.accepted_date =
                this.formEstimates.accepted_date == null ||
                this.formEstimates.accepted_date == ""
                    ? null
                    : new Date(
                          (
                              new Date(this.formEstimates.accepted_date).toISOString() +
                              ""
                          ).slice(0, 10) + "T23:31:04.000Z"
                      ).toISOString();
        },
        EstimateById() {
            window.billingSales
                .get("estimate/" + this.$parent.dataSales.est_id)
                .then((response) => {
                    let dataR = response.data;
                    let estCustomer = dataR.customer;
                    let estItem = dataR.result;
                    this.formEstimates.customer_id = estCustomer.id;
                    this.formEstimates.idEst = response.data.result.id;
                    this.formEstimates.numdoc = response.data.result.numdoc;
                    this.formEstimates.job_information = response.data.result.job_information;
                    this.formEstimates.estimates_optional = response.data.result.estimate_optional;
                    this.formEstimates.customer_message = response.data.result.customer_message;
                    console.log('formEstimates.customer_message', this.formEstimates.customer_message)
                    this.formEstimates.date_create = response.data.result.date_create
                    this.formEstimates.accepted_by = response.data.result.accepted_by;
                    this.formEstimates.accepted_date = response.data.result.accepted_date
                    this.formEstimates.status = response.data.result.status;
                    this.formEstimates.actionNname = "update";
                    // this.inputFecha = this.formEstimates.accepted_date; // ya no se usa
                    this.formEstimates.checked = response.data.result.need_contract == 1;
                    this.formEstimates.checked = estItem.need_contract == 1;
                    this.formEstimates.letter = estItem?.isLetter == 1;
                    this.selectedContract = this.formEstimates.checked ? 1 : (this.formEstimates.letter ? 2 : 0); // contrato o carta
                    this.formEstimates.isAttacImg = estItem?.isAttacImg == 1;
                    this.formEstimates.attcImg= estItem?.attcImg ? JSON.parse(estItem?.attcImg) : [];
                    this.formEstimates.signe = estItem.signe == 1;
                    this.formEstimates.signe = response.data.result.signe == 1;
                    this.formEstimates.subtotal = response.data.result.sub_total;
                    this.formEstimates.discount_type = response.data.result.discount_type;
                    this.formEstimates.discount_mount = response.data.result.discount_mount;
                    this.formEstimates.discount_total = response.data.result.discount_total;
                    this.formEstimates.discount_name = response.data.result.discount_name;
                    this.formEstimates.total = response.data.result.total;
                    // console.log('optionsExtras', response.data.result.options_extras)
                    this.formEstimates.optionsExtras = response.data.result.options_extras ? JSON.parse(response.data.result.options_extras) : { navCustomer: { textBox: true, payment: false }, paymentPlan: null };
                    // console.log('formEstimates.optionsExtras', this..formEstimates.optionsExtras)
                    this.navCustomer = this.formEstimates.optionsExtras.navCustomer;
                    this.paymentPlan = this.formEstimates.optionsExtras.paymentPlan;
                    // console.log('paymentPlan', this.paymentPlan)
                    this.taxShow = (dataR.taxShow != null && dataR.taxShow.meta_value == 1) ? 1 : 0;
                    this.type_estimate = (dataR.type_estimate != null && dataR.type_estimate.meta_value == 'pro') ? 'pro' : 'normal';
                    if (this.type_estimate == 'normal' && this.taxShow == 0) { this.taxShow = 1; } // sino es un estpro, siempre activar taxes
                    this.groupShow = (dataR.groupShow != null && dataR.groupShow.meta_value == 1) ? 1 : 0;
                    this.selectCTemplate.description = estItem.terms_conditions_desc;
                    this.selectCTemplate.title = estItem.terms_conditions_title;
                    this.templateLetter.title = estItem.letter_title;
                    this.templateLetter.description = estItem.letter_description;
                    this.FormSignature.dateCustomer = new Date(estItem.signaturecustomerdate);
                    this.FormSignature.dateCompany = new Date(estItem.signaturecompanydate);
                    this.itemsprod = response.data.itemsprod;
                    console.log('itemsprod', this.itemsprod)
                    this.selectBillTo(response.data.customer.id);
                    localStorage.removeItem("dataOrigin"); // removemos datos antiguos
                    setTimeout(() => {
                        this.loadEstByID = true;
                        // tiempo de espera para q los datos se ajusten antes de almacenar
                        localStorage.setItem("dataOrigin", JSON.stringify(this.createDataSend()))
                    }, 600);
                    this.$parent.isLoading = false;
                })
                .catch((error) => {
                    console.log(error);
                    this.$parent.isLoading = false;
                    this.disabledSteps.customer = false;
                });
        },
        selectBillTo(idc) {
            for (let item in this.CustomersList) {
                let id = this.CustomersList[item].value;
                if (idc > 0 && idc == id) {
                    this.ValuesCustomers = {
                        text: this.CustomersList[item].text,
                        value: this.CustomersList[item].value,
                        billing_address: this.CustomersList[item].billing_address,
                        bussinesname: this.CustomersList[item].bussinesname,
                        customer_address: this.CustomersList[item].customer_address,
                        customer_name: this.CustomersList[item].customer_name,
                        customer_lastname: this.CustomersList[item].customer_lastname,
                        customer_phone: this.CustomersList[item].customer_phone,
                        customer_officephone: this.CustomersList[item].customer_officephone,
                        email: this.CustomersList[item].email,
                        city: this.CustomersList[item].city,
                        state: this.CustomersList[item].state,
                        code: this.CustomersList[item].code,
                    };
                }
            }
            console.log("customer seleccionado", this.ValuesCustomers);
        },
        getResponseDateDoc(data, nameField) {
            let t = this;
            console.log("getResponseDateDoc", data.date_doc)
            t.formEstimates[nameField] = data.date_doc;
            t.updateDateNewFormat(nameField);
        },
        updateDateNewFormat(nameField) {
            if (!this.formEstimates[nameField]) return;
            let parts = this.fragmetarFecha(this.formEstimates[nameField]);
            let date = parts[0]+'-'+parts[1]+'-'+(parts[2] > 9 ? parts[2] : ((parts[2]).toString().length==1) ? '0'+parts[2] : parts[2]); // Año-(Mes-1)-Día
            console.log('updateDateNewFormat', date);
            this.formEstimates[nameField] = date + 'T23:31:04.000Z'; // Añade la hora
        },
        fragmetarFecha(dateValue) {
            if (!dateValue) return;
            // console.log('fragmetarFecha', dateValue);
            let dateSinHoras = (dateValue.indexOf('T')>-1) ? dateValue.split("T")[0] : dateValue;
            // console.log('dateSinHoras', dateSinHoras);
            let parts = dateSinHoras.split("-");
            // console.log('parts', parts);
            return parts;
        },
        updateJobInfo(d) {
            let t = this;
            // console.log('updateJobInfo', d)
            t.formEstimates.estimates_optional = d.document_name
            t.formEstimates.job_information = d.job_information
        },
        setProd(d) {
            let t = this;
            // console.log('setProd', d)
            this.itemProducts = d.itemProducts;
            t.taxShow = d.taxShow;
            t.groupShow = d.groupShow;
            t.taxesResumen = d.taxesResumen;
        },
        setMessage(customer_message) {
            let t = this;
            console.log('setMessage', customer_message)
            t.formEstimates.customer_message = customer_message;
        },
        setAlert(msj) {
            let t = this;
            // console.log('setAlertError', msj)
            t.msjAlert(msj);
        },
        setTotales(d) {
            let t = this;
            // console.log('setTotales', d)
            t.formEstimates.subtotal = d.subtotal;
            t.formEstimates.discount_type = d.discount_type;
            t.formEstimates.discount_mount = d.discount_mount;
            t.formEstimates.discount_total = d.discount_total;
            t.formEstimates.discount_name = d.discount_name;
            t.formEstimates.totaltax = d.totaltax;
            t.formEstimates.total = d.total;
            // console.log('setTotales', t.form)
        },
        setContract(d) {
            let t = this;
            // console.log('setContract', d)
            t.formEstimates.checked = d.includeContract;
            t.formEstimates.signe = d.signe;
            t.formEstimates.customer_name = d.customer_name;
            t.selectCTemplate.id = d.selectCTemplate.id;
            t.selectCTemplate.title = d.selectCTemplate.title;
            t.selectCTemplate.description = d.selectCTemplate.description;
            t.FormSignature.dateCustomer = d.FormSignature.dateCustomer;
            t.FormSignature.dateCompany = d.FormSignature.dateCompany;
            t.FormSignature.nameCompany = d.FormSignature.nameCompany;
        },
        setNavContract(d) {
            // console.log('setNavContract', d)
            this.selectedContract = d.id;
        },
        showFormOption(d){
            // console.log('showFormOption', d)
            if(d.type=='contract'){
                this.formEstimates.checked = d.value;
            }
            else if(d.type=='letter'){
                this.formEstimates.letter = d.value;
            }
            else if(d.type=='attachImg'){
                this.formEstimates.isAttacImg = d.value;
            }
            this.selectedContract = d.tabActive;
        },
        setLetter(d) {
            let t = this;
            // console.log('setLetter', d)
            t.formEstimates.letter = d.letter;
            t.templateLetter.title = d.title;
            t.templateLetter.description = d.description;
        },
        setAttachImg(d) {
            let t = this;
            // console.log('setAttachImg', d)
            // t.formEstimates.isAttacImg = d.isAttacImg;
            t.formEstimates.attcImg = d.attcImg;
        },
        setPayments(d){
            let t = this;
            if(Array.isArray(d)){
                t.paymentPlan = d;
                t.formEstimates.optionsExtras.paymentPlan = d;
            }
            console.log('setPayments', t.formEstimates.optionsExtras.paymentPlan)
        },
        changeNavCustomer(d){
            let t = this;
            // console.log('changeNavCustomer', d);
            t.navCustomer = d;
            t.formEstimates.optionsExtras.navCustomer = d;
        },
	},
	watch: {
        itemProducts: function(_newVal, _oldVal){
            console.log('watch itemsprod', this.itemProducts)
        },
        inputFecha: function () {
            this.formatearFecha();
            // this.formEstimates.date_create = this.inputFecha;
        },
        "FormSignature.dateCustomer": function () {
            this.formatearFechaContrato2();
            // this.dateCustomer = this.FormSignature.dateCustome;
        },
        "FormSignature.dateCompany": function () {
            this.formatearFechaContrato();
            // this.dateCompany = this.FormSignature.dateCompany;
        },
        "$parent.step": function(){
            console.log('watch step ', this.$parent.step)
            if(this.$parent.step==2){
                this.getCustomerID();
                // this.getTaxes();
                this.getCTemplates();
            }
        },
        'getActionRefresh': function() {
            console.log('getActionRefresh', this.getActionRefresh)
            if (Object.keys(this.getActionRefresh.data).length > 0) {
                let data = this.getActionRefresh.data; 
                let methods = this.getActionRefresh.action;
                if (methods === 'newCustomer') {
                    this.ValuesCustomers = data;
                    // this.getCustomer();
                }
                if (methods === 'products') {
                    this.ProdServiceLists.push(data.model);
                    this.formList.items[
                        this.FormAddPS.index_modal
                    ].options = this.ProdServiceLists;
                    this.formList.items[
                        this.FormAddPS.index_modal
                    ].model = data.model;
                }
                this.m = {
                    show: false,
                    component: '',
                    data: {}
                }
            }
        },
	},
    computed: {
        ...mapGetters("core", { getOpenModal: "getOpenModal", getActionRefresh: "getActionRefresh" }),
    }
}
</script>
<style lang="scss" scoped>
.iva_block {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 5px;
    .itemsb {
        display: flex;
        justify-content: flex-end;
        width: 100%;
    }
}
.deletebtn {
    position: absolute;
    right: -24px;
    top: 22px;
    width: 24px;
    height: 20px;
    background-color: #f12e2e;
    cursor: pointer;
    font-size: 20px;
    color: #fff;
    text-align: center;
    vertical-align: middle;
    padding: 7px;
    line-height: 0px;
    &:hover {
        background-color: #c12727;
    }
}
.pageSignature {
    display: block;
    margin-top: 20px;
    width: 100%;
}
.flip-list-move {
    transition: transform 0.5s;
}
.no-move {
    transition: transform 0s;
}
.ghost {
    opacity: 0.5;
    background: #a0a0a0;
}
.ui.fluid.search.selection.dropdown.productos {
    width: 90%;
    float: left;
    display: inline-block;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
}
.btninv {
    position: relative;
    left: initial;
    top: 0;
    width: 20px;
    height: 38px;
    cursor: pointer;
    background-color: #fff;
    z-index: 10;
    color: #333;
    font-size: 18px;
    text-align: center;
    vertical-align: middle;
    line-height: 34px;
    font-weight: 400;
    border: 1px solid #dedede;
    float: right;
    display: inline-block;
    display: none !important;
    margin-left: -6px;
    &:hover {
        background-color: #e0e0e0;
    }
}
.btnmove {
    position: absolute;
    left: -13px;
    top: -3px;
    width: 13px;
    height: 100%;
    cursor: pointer;
    background-color: #e1f2fb;
    z-index: 10;
    color: #afafaf;
    font-size: 12px;
    line-height: 75px;
    text-align: center;
    vertical-align: middle;
    font-weight: normal;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    &:hover {
        background-color: #e0e0e0;
        cursor: move;
    }
}
.table-productos {
    width: 100%;
}
.bill_to {
    display: block;
    width: 100%;
    padding: 0.375rem 0.75rem;
    font-size: 0.8rem;
    line-height: 1.5;
    color: #4f5467;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #dedede;
    border-radius: 2px;
    height: 135px;
}
#job_information {
    height: 130px;
}
#CustomersList .ui.selection.dropdown .menu {
    border-top: 1px solid #d4d0c8 !important;
}
@media (max-width: 1100px) {
    .table-productos {
        position: relative;
        display: block;
        padding-left: 15px;
        width: 100%;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        -ms-overflow-style: -ms-autohiding-scrollbar;
    }
    .table-productos table {
        width: 860px;
    }
}
@media (max-width: 800px) {
    .table-productos {
        max-width: 800px;
    }
}
.error {
    border-color: red !important;
}
</style>
